import { useDrag } from "@use-gesture/react";
import { useSpring, animated } from "@react-spring/web";
import { useRef, useLayoutEffect, useState } from "react";

const DragScroll = ({ children }) => {
  const containerRef = useRef(null);
  const [bounds, setBounds] = useState({ left: 0, right: 0 });

  // spring state
  const [{ x }, api] = useSpring(() => ({ x: 0 }));

  // measure width so we know bounds
  useLayoutEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.scrollWidth;
      const viewportWidth = containerRef.current.offsetWidth;
      const maxScroll = containerWidth - viewportWidth;

      setBounds({
        left: -maxScroll, // can drag left up to negative maxScroll
        right: 0,         // can't drag beyond starting point
      });
    }
  }, [children]);

  // gesture binding
  const bind = useDrag(
    ({ offset: [dx] }) => {
      api.start({ x: dx });
    },
    {
      axis: "x",
      bounds,
      rubberband: true,
      from: () => [x.get(), 0], // start from current spring value
    }
  );

  return (
    <div style={{ touchAction: "none", overflow: "hidden" }}>
      <animated.div  {...bind()} style={{ x }} className="drag-scroll" >
        {children}
      </animated.div>
    </div>
  );
};

export default DragScroll;